import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { SignInWithEmailIcon } from '@dynamic-labs/iconic';
import { Typography } from '../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '../../config/LSSuffix.js';
import '@dynamic-labs/wallet-connector-core';
import { useViewContext } from '../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgError } from '../../shared/assets/error.js';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import 'ethers';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/multi-wallet';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../context/ErrorContext/ErrorContext.js';
import { useAccessDeniedContext } from '../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../components/IconButton/IconButton.js';
import { IconWithStatus } from '../../components/IconWithStatus/IconWithStatus.js';
import { Button } from '../../components/Button/Button.js';
import '../../components/Alert/Alert.js';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import '@dynamic-labs/wallet-book';
import 'formik';
import 'yup';
import '../../components/MenuList/Dropdown/Dropdown.js';
import { StatusDot } from '../../components/StatusDot/StatusDot.js';
import { getSocialNetworkIcon } from '../../utils/functions/getSocialNetworkIcon/getSocialNetworkIcon.js';
import { useEmailVerificationContext } from '../../context/EmailVerificationContext/EmailVerificationContext.js';
import { AuthProviderIcon } from '../../components/AuthProviderIcon/AuthProviderIcon.js';

const NoAccess = () => {
    const { deniedAddress, setDeniedAddress, setDeniedOauthProvider } = useAccessDeniedContext();
    const { selectedWalletConnector: walletConnector, socialMediaLinkText, socialMediaIconUrl, socialMediaUrl, notInTheListImageUrl, accessDeniedMessagePrimary, accessDeniedMessageSecondary, accessDeniedButton, onboardingOnlyJwt, } = useInternalDynamicContext();
    const { email } = useEmailVerificationContext();
    const { goToInitialView, view } = useViewContext();
    const isChainalysisView = view === 'chainalysis-blocked-wallet';
    const _socialMediaLinkText = !isChainalysisView
        ? socialMediaLinkText
        : 'Why am I seeing this message?';
    const _socialMediaUrl = !isChainalysisView
        ? socialMediaUrl
        : 'https://docs.dynamic.xyz/docs';
    const handleChangeWallet = () => {
        goToInitialView();
        setDeniedAddress('');
        setDeniedOauthProvider(undefined);
        walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.endSession();
    };
    const title = isChainalysisView
        ? 'This address seems corrupted.'
        : accessDeniedMessagePrimary || 'Access denied';
    const subtitle = isChainalysisView
        ? 'This wallet has been correlated to illicit activity and cannot access this site.'
        : accessDeniedMessageSecondary ||
            "We couldn't find your wallet address or email on our allow list of customers.";
    const buttonTitle = (accessDeniedButton === null || accessDeniedButton === void 0 ? void 0 : accessDeniedButton.title) || 'Try another method';
    const buttonAction = (accessDeniedButton === null || accessDeniedButton === void 0 ? void 0 : accessDeniedButton.action) || handleChangeWallet;
    const SocialMediaIcon = !socialMediaIconUrl || typeof socialMediaIconUrl === 'string'
        ? null
        : getSocialNetworkIcon(Object.keys(socialMediaIconUrl)[0]);
    const Icon = useMemo(() => {
        if (walletConnector) {
            return jsx(AuthProviderIcon, { jwt: onboardingOnlyJwt });
        }
        return (jsx(IconWithStatus, { containerClassName: 'wallet-no-access__icon--verified', Icon: SignInWithEmailIcon, iconSize: 50, InnerIcon: SvgError, variant: 'red' }));
    }, [onboardingOnlyJwt, walletConnector]);
    const formattedAddress = deniedAddress.replace(deniedAddress.substring(6, Number(deniedAddress === null || deniedAddress === void 0 ? void 0 : deniedAddress.length) - 4), '...');
    const emailOrAddress = email !== null && email !== void 0 ? email : formattedAddress;
    return (jsxs("div", Object.assign({ className: 'wallet-no-access__container' }, { children: [notInTheListImageUrl && !isChainalysisView && (jsx("img", { src: notInTheListImageUrl, alt: 'user is not in the list', className: 'wallet-no-access__image' })), jsxs("div", Object.assign({ className: 'wallet-no-access__main' }, { children: [jsxs("div", Object.assign({ className: 'wallet-no-access__user-info-container' }, { children: [Icon, jsxs("div", Object.assign({ "data-testid": 'walletAddress', className: 'wallet-no-access__wallet-address-container' }, { children: [walletConnector && (jsx(StatusDot, { variant: 'red', containerClassName: 'user-info__status-dot' })), jsx(Typography, Object.assign({ variant: 'body_normal', color: 'primary', weight: 'medium', className: 'wallet-no-access__wallet-address' }, { children: emailOrAddress }))] }))] })), jsxs("div", Object.assign({ className: 'wallet-no-access__content' }, { children: [jsx(Typography, Object.assign({ variant: 'title', color: 'primary', className: 'wallet-no-access__content--primary' }, { children: title })), jsx(Typography, Object.assign({ variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'wallet-no-access__content--secondary' }, { children: subtitle }))] })), jsx(Button, Object.assign({ onClick: buttonAction, className: 'wallet-no-access__button--primary', expanded: true, buttonRounded: 'default', buttonPadding: 'large' }, { children: buttonTitle })), Boolean(_socialMediaUrl) && Boolean(_socialMediaLinkText) && (jsxs("div", Object.assign({ className: 'wallet-no-access__social-info-container' }, { children: [jsxs("a", Object.assign({ href: _socialMediaUrl, className: 'wallet-no-access__waitlist-link' }, { children: [jsx(Typography, Object.assign({ variant: 'button_primary', color: 'primary' }, { children: _socialMediaLinkText })), SocialMediaIcon && !isChainalysisView && (jsx(SocialMediaIcon, { className: 'wallet-no-access__social-icon', style: {
                                            height: pixelToRem(24),
                                            width: pixelToRem(24),
                                        } }))] })), typeof socialMediaIconUrl === 'string' && (jsx("img", { alt: 'social media', src: socialMediaIconUrl, style: {
                                    height: '1.5rem',
                                    width: '1.5rem',
                                } }))] })))] }))] })));
};

export { NoAccess };
